/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsIdQueryResponse,
  GetTournamentsIdPathParams,
  GetTournamentsId404,
} from "../types/GetTournamentsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsIdQueryKey = (
  id: GetTournamentsIdPathParams["id"] | undefined,
) => [{ url: "/tournaments/:id", params: { id: id } }] as const;

export type GetTournamentsIdQueryKey = ReturnType<
  typeof getTournamentsIdQueryKey
>;

/**
 * @summary Получение информации о турнире по ID
 * {@link /tournaments/:id}
 */
export async function getTournamentsId(
  id: GetTournamentsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsIdQueryResponse,
    ResponseErrorConfig<GetTournamentsId404>,
    unknown
  >({ method: "GET", url: `/tournaments/${id}`, ...requestConfig });
  return res;
}

export function getTournamentsIdQueryOptions(
  id: GetTournamentsIdPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsIdQueryKey(id);
  return queryOptions<
    ResponseConfig<GetTournamentsIdQueryResponse>,
    ResponseErrorConfig<GetTournamentsId404>,
    ResponseConfig<GetTournamentsIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsId(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получение информации о турнире по ID
 * {@link /tournaments/:id}
 */
export function useGetTournamentsId<
  TData = ResponseConfig<GetTournamentsIdQueryResponse>,
  TQueryData = ResponseConfig<GetTournamentsIdQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsIdQueryKey,
>(
  id: GetTournamentsIdPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsIdQueryResponse>,
        ResponseErrorConfig<GetTournamentsId404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getTournamentsIdQueryKey(id);

  const query = useQuery(
    {
      ...getTournamentsIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTournamentsId404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
